import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import ECharts from '~/components/echarts'
import {
  organizationAWSOpensearchOptimizationRightSizeRecommendationCpuChartPath,
  organizationAWSOpensearchOptimizationRightSizeRecommendationMasterCpuChartPath,
} from '~/routes'

export default function AwsOpensearchCpuRightSizeRecommendationsCharts({
  organizationId: orgId,
  resourceId: reId,
  optimizationId: optId,
}) {
  const params = { metrics_time_frame: '1w' }

  const OpensearchCpuChartUrl = useMemo(
    () => organizationAWSOpensearchOptimizationRightSizeRecommendationCpuChartPath(orgId, optId, reId),
    [orgId, optId, reId],
  )
  const OpensearchMasterCpuChartUrl = useMemo(
    () => organizationAWSOpensearchOptimizationRightSizeRecommendationMasterCpuChartPath(orgId, optId, reId),
    [orgId, optId, reId],
  )

  return (
    <div className='card'>
      <div className='card-body'>
        <div className='row g-0'>
          <div className='col-sm-12'>
            <ECharts
              title={t`CPU Utilization`}
              chartInfoTitle='aws_opensearch_recommendations_cpu_utilization'
              url={OpensearchCpuChartUrl}
              params={params}
            />
          </div>

          <div className='col-sm-12'>
            <ECharts
              title={t`Master CPU Utilization`}
              chartInfoTitle='aws_opensearch_recommendations_master_cpu_utilization'
              url={OpensearchMasterCpuChartUrl}
              params={params}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
